import "./index.scss";
import LoggedOutLayout from "features/layouts/pages/logged-out";
import Modal from "features/components/modal";
import Title from "features/components/title";
import Text from "features/components/text";
import React from 'react';
import Button from "../../../components/button";



export const ResetSuccess = (props) => {
    function openApp() {
        return window.location.href = 'osa-app://recover-password-success';
    }
    return <LoggedOutLayout type={"dark"} className={"login-page"}>
        <Modal>
            <Title size={34} align={"center"}>La password è stata resettata con successo</Title>
            <Title size={32} align={"center"}>Ora puoi ritornare all'applicazione</Title>
            <br/><br/>

            <Button title={'Apri Applicazione'} onClick={() => openApp()}/>
            <Text size={16}><a href="/">Torna indietro</a></Text>
        </Modal>
    </LoggedOutLayout>
}


export default ResetSuccess;
